export default __webpack_public_path__ + "static/media/circle-check-black.80408f9c.svg";